import {mapGetters, mapMutations} from 'vuex';
import ServiceApi from "../../services/ServiceApi";

export default {
    data: () => ({
        kitsFolderPosition: {},
        folderSize: '',
    }),
    computed: {
        /** Проксируем геттеры из стора */
        ...mapGetters('folders', ['folders']),
        /**
         * Активированные папки
         * @returns {Array}
         */
        kitsFolderIdsActive() {
            const kitsFolderIdsActive = this.folders.map(folder => {
                const {id = '-1'} = folder;
                return String(id);
            });
            return kitsFolderIdsActive;
        },
    },
    methods: {
        /** Проксируем мутациииз стора */
        ...mapMutations('folders', ['openFolder', 'closeFolder', 'bringToFront']),
        /**
         * Переключить отображение папки
         * @param {String} id - идентификатор набора
         * @param {String} type - тип набора
         */
        toggleFolder(id = '-1', type = '') {
            if (!this.kitsFolderIdsActive.includes(String(id))) {
                this.kitsFolderPosition = {
                    ...this.kitsFolderPosition,
                    [id]: {...this.calculatePositionFolder(type)}
                };
                this.openFolder(String(id));
            }
            else
                this.closeFolder(String(id));
        },
        /**
         * Вычислить позицию для таблицы открывающегося элемента набора
         * @param {String} type - тип элемента набора (found|custom)
         */
        calculatePositionFolder(type = '') {
            let position = {top: '0', left: '0'};
            if (type === 'found') {
                position = {
                    top: `80px`,
                    left: '0'
                };
            }
            if (type === 'custom') {
                const kitsTableActiveCustom = this.kitsFolderIdsActive.filter(kitId => String(kitId) !== String(this.kitFoundId));
                position = {
                    top: `${80 + kitsTableActiveCustom.length * 30}px`,
                    left: `${0 + kitsTableActiveCustom.length * 30}px`,
                };
            }

            return position;
        },
        /**
         * Рассчитать ширину папки
         * @param {String} type - тип папки
         * @param {String} size - размер окна на весь экран, половина экрана, страндартный
         * @return {String}
         */
        calculateFolderWidth(type = '', size = '') {
            let width = '100%';
            if (type === 'found' && size === '') {
                width = `${Math.ceil(window.innerWidth * 0.7)}px`;
            }
            if (type !== 'found' && size === '') {
                width = `${Math.ceil(window.innerWidth * 0.5)}px`;
            }

            return width;
        },
        /**
         * Рассчитать высоту папки
         * @param {String} type - тип папки
         * @param {String} size - размер окна на весь экран, половина экрана, страндартный
         * @return {String}
         */
        calculateFolderHeight(type = '', size = '') {
            let height = 'calc(100vh - 150px)';
            if (type === 'found' && size === '') {
                height = `${Math.ceil(window.innerHeight * 0.65)}px`;
            }
            if (type !== 'found' && size === '') {
                height = '300px';
            }
            return height;
        },
        /**
         * Получить позицию для таблицы открывающегося элемента набора
         * @param {String} id - идентификатор элемента набора
         * @param {String} position - top или left позиция
         * @param {String} size - размер окна на весь экран, половина экрана, страндартный
         */
        getPositionFolderKit(id = -1, position = '', size = '') {
            if(Object.keys(this.kitsFolderPosition).includes(String(id)) && size === '') {
                return this.kitsFolderPosition[id][position];
            }

            return '0';
        },

        /**
         * Получение кластеров и маркеров набора
         * @param {Object} postData
         * @param {Function} actionAfter
         * @returns {Promise<void>}
         */
        async postMarkersAndClustersDataCustom(postData = {}, actionAfter = () => {}) {
            try {
                const res = await ServiceApi.post('free', '/map/set-clusters', postData);
                const {data: responseData = {}} = res;
                const {data = []} = responseData;
                actionAfter(data);
            }
            catch(error) {
                console.log(error);
            }
        },
    }
};
